import de from './de.json'
import terms from './terms'

const messages = {
  ...de,
  terms,
}

export default messages
